import React from 'react';
import PanelGroups from './PanelGroups';
import strings from './strings';

/**
 * The phone "More" sheet: everything that is not on the dock, as the same
 * collapsible groups the desktop sidebar shows (PanelGroups), touch-sized
 * by practice-panel.css. `locked`: playing or paused.
 */
const MobileMoreSheet = ({ controls, locked, partsOverride, onPartsOverride, stepHints, onStepHints, stepHintsAvailable, lyrics, onClose }) => (
  <div className="mps-more" role="dialog" aria-label={strings.more}>
    <header className="mps-topbar sheet">
      <button type="button" className="mps-icon-btn" onClick={onClose} aria-label={strings.close}>&times;</button>
      <div className="mps-title">{strings.more}</div>
    </header>
    <div className="mps-more-body">
      <PanelGroups
        controls={controls}
        locked={locked}
        phone
        partsOverride={partsOverride}
        onPartsOverride={onPartsOverride}
        stepHints={stepHints}
        onStepHints={onStepHints}
        stepHintsAvailable={stepHintsAvailable}
        lyrics={lyrics}
      />
    </div>
  </div>
);

export default MobileMoreSheet;
